/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenanceTimerResponseDto
 */
export interface PartnerMaintenanceTimerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceTimerResponseDto
     */
    kind: PartnerMaintenanceTimerResponseDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceTimerResponseDto
     */
    clockStart?: PartnerMaintenanceTimerResponseDtoClockStartEnum | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceTimerResponseDto
     */
    calendarMode?: PartnerMaintenanceTimerResponseDtoCalendarModeEnum | null;
}


/**
 * @export
 */
export const PartnerMaintenanceTimerResponseDtoKindEnum = {
    TakeCharge: 'TAKE_CHARGE',
    Intervention: 'INTERVENTION',
    Resolution: 'RESOLUTION'
} as const;
export type PartnerMaintenanceTimerResponseDtoKindEnum = typeof PartnerMaintenanceTimerResponseDtoKindEnum[keyof typeof PartnerMaintenanceTimerResponseDtoKindEnum];

/**
 * @export
 */
export const PartnerMaintenanceTimerResponseDtoClockStartEnum = {
    IncidentDetected: 'INCIDENT_DETECTED',
    FaultReported: 'FAULT_REPORTED',
    TicketCreated: 'TICKET_CREATED',
    TicketTakenInCharge: 'TICKET_TAKEN_IN_CHARGE',
    FirstIntervention: 'FIRST_INTERVENTION'
} as const;
export type PartnerMaintenanceTimerResponseDtoClockStartEnum = typeof PartnerMaintenanceTimerResponseDtoClockStartEnum[keyof typeof PartnerMaintenanceTimerResponseDtoClockStartEnum];

/**
 * @export
 */
export const PartnerMaintenanceTimerResponseDtoCalendarModeEnum = {
    Continuous247: 'CONTINUOUS_24_7',
    ExcludingWeekendsAndHolidays: 'EXCLUDING_WEEKENDS_AND_HOLIDAYS',
    BusinessHours: 'BUSINESS_HOURS'
} as const;
export type PartnerMaintenanceTimerResponseDtoCalendarModeEnum = typeof PartnerMaintenanceTimerResponseDtoCalendarModeEnum[keyof typeof PartnerMaintenanceTimerResponseDtoCalendarModeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceTimerResponseDto interface.
 */
export function instanceOfPartnerMaintenanceTimerResponseDto(value: object): value is PartnerMaintenanceTimerResponseDto {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceTimerResponseDtoFromJSON(json: any): PartnerMaintenanceTimerResponseDto {
    return PartnerMaintenanceTimerResponseDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceTimerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceTimerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'clockStart': json['clockStart'] == null ? undefined : json['clockStart'],
        'calendarMode': json['calendarMode'] == null ? undefined : json['calendarMode'],
    };
}

export function PartnerMaintenanceTimerResponseDtoToJSON(json: any): PartnerMaintenanceTimerResponseDto {
    return PartnerMaintenanceTimerResponseDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceTimerResponseDtoToJSONTyped(value?: PartnerMaintenanceTimerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'clockStart': value['clockStart'],
        'calendarMode': value['calendarMode'],
    };
}

